export default __webpack_public_path__ + "static/s7-828bd034967a5500a33f59e093771f97.webp";